import { ESdChangeReason, RightPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";

export interface WorkflowVersionButtonState {}

export interface WorkflowVersionButtonProps {}

class WorkflowVersionButton extends PureSdComponent<
  WorkflowVersionButtonProps & IWithSDProps,
  WorkflowVersionButtonState
> {
  constructor(props: WorkflowVersionButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.WorkflowVersionButton) === Visibility.Visible && (
          // <KuikaTooltip position="left" content="Version History">
          <KuikaButton
            data-testid="workflowVersionHistoryButton"
            type="tertiary"
            size="md"
            isIcon
            color="neutral"
            active={this.props.sd.getActiveRightPanel() === RightPanelType.WorkflowVersion}
            onClick={() => this.props.sd.setActiveRightPanelByClick(RightPanelType.WorkflowVersion)}
          >
            <KuikaSvg name="file-time" width={18} height={18} pointer />
          </KuikaButton>
          // </KuikaTooltip>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock
    ) {
      return true;
    }
    return false;
  };
}

const workflowVersionButton = withSD<WorkflowVersionButtonProps>(WorkflowVersionButton);
export { workflowVersionButton as WorkflowVersionButton };
